import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface PricingCTAProps {
  variant?: 'compact' | 'full';
  className?: string;
}
export function PricingCTA({
  variant = 'full',
  className = ''
}: PricingCTAProps) {
  return <div className={`flex flex-col items-center text-center ${className}`} data-id="element-101">
      {variant === 'full' && <div className="mb-6 space-y-2" data-id="element-102">
          <p className="text-2xl font-serif font-bold text-navy" data-id="element-103">
            Planeación 10X — 299 MXN
          </p>
          <p className="text-gray-600" data-id="element-104">
            PDF + plantillas editables (Google Docs/Slides)
          </p>
        </div>}

      <motion.button whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} onClick={() => {
      const el = document.getElementById('pricing');
      if (el) el.scrollIntoView({
        behavior: 'smooth'
      });
    }} className="bg-amber text-navy font-bold text-lg md:text-xl px-8 py-4 rounded-lg shadow-lg hover:shadow-xl transition-shadow flex items-center gap-2" data-id="element-105">
        QUIERO PLANEACIÓN 10X
        <ArrowRight className="w-5 h-5" data-id="element-106" />
      </motion.button>

      {variant === 'compact' && <p className="mt-3 text-sm text-gray-500" data-id="element-107">299 MXN • Acceso inmediato</p>}
    </div>;
}